import "./edit-employee-timeline.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormEmployeeTimeline from "../form-employee-timeline/form-employee-timeline";
import { useEditEmployeeTimeline } from "./edit-employee-timeline.hook";

export function EmployeeTimeline() {
  const {
    employeeTimelineData,
    isLoading,
    employeeTimelineError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditEmployeeTimeline();

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
        <FormEmployeeTimeline />
      </section>
    </div>
  );

  return (
    <div id="EmployeeTimeline" className="employee-timeline">
      <HeaderContent
        title={"Edit Employee Timeline"}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {employeeTimelineError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EmployeeTimeline;
